import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    load: false,
    bread_val: null,
    render: true,
  },
  getters: {
    load: state => state.load,
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    bread_val(state) {
      return state.bread_val
    },
    rerender: state => state.rerender,
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    UPDATE_BREAD_VAL(state, val) {
      state.bread_val = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_LOAD(state, val) {
      state.load = val
    },
    UPDATE_RERENDER(state, val) {
      state.rerender = val
    },

  },
  actions: {},
}
